import React from 'react';
import ReactDOM from 'react-dom';
import {configureStore} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";
import {Provider} from 'react-redux';
import {connect} from 'react-redux';
import store from './Dashboard'
import FeedbackList from '../FeedbackList';
import FeedbackDetail from '../FeedbackDetail';
import SearchBar from '../SearchBar';
import StatsBar from '../StatsBar';
import StatsTable from '../StatsTable';
import Modal from '../Modal';
import Loading from '../Loading';
import {connectWebsocket, setSelectedFeedback, setNotificationPermission} from '../redux/FeedbackRedux';

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = { showChat: false };
        this.toggleChat = this.toggleChat.bind(this)
    }

    toggleChat() {
        this.setState({ showChat: !this.state.showChat })
    }

    render() {
        return (
            <div className="container-fluid">
                <Loading location={'page'}/>
                <div className="row dashboard-stats">
                    <StatsBar/>
                    <StatsTable/>
                    <SearchBar title="All Open Feedbacks" searchType="standard"/>
                </div>
                <div className="row feedbacks">
                    {this.props.state.initial_feedbacks != null &&
                        <FeedbackList/>
                    }
                    {this.props.state.feedback_detail != null &&
                        <FeedbackDetail toggleChat={this.toggleChat} showChat={this.state.showChat} />
                    }

                    {this.props.state.initial_feedbacks == null &&
                        <div className="col-md-12 nonefound">
                            <h5 className="text-center">No {(this.props.state.status != "All" && this.props.state.status != null ? this.props.state.status : '')} Feedbacks
                                Found {(this.props.state.query !== null ? 'with: ' + this.props.state.query : '')}</h5>
                        </div>
                    }
                </div>
                {this.props.state.feedback_detail != null &&
                    <Modal modal={this.props.state.modal}/>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(Dashboard)
